module.exports = __webpack_public_path__ + "d24278f83921e0d7f6832efe37a55d0e.svg";